import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../incomeTaxBase.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  fileServicesValidation = new Subject<any>();
  fileServicesValidation$ = this.fileServicesValidation.asObservable();
  private baseUrl: string = environment.apiUrlV1;
  constructor(
    private baseService: BaseService,
    private httpClient: HttpClient
  ) { }

  FileServicesValidate(headers: HttpHeaders): Observable<HttpResponse<null>> {
    return this.baseService.getApi<HttpResponse<null>>({ methodPath: 'Common/FileServicesValidate' }, { headers: headers })
  }
}